import { Component, input } from '@angular/core';

/**
 * Renders the designer-provided "TrustBridge Global" donate button preview image (light/dark
 * variants), used by the "Select Button Style" picker in the Donate Now tab. This is a genuine
 * high-resolution export from the designer — border/shadow/rounded corners are baked into the
 * image itself, so no wrapping chrome is needed here (unlike the earlier hand-recreated
 * SVG/CSS markup this replaced, which existed only because the previous asset turned out to be
 * a low-fidelity export with no higher-resolution version available).
 *
 * This is a preview swatch only — the actual embeddable button image in the generated embed
 * code is unrelated and still comes from `environment.fund.{light,dark}DonateNowButtonLink`.
 *
 * @example
 * ```html
 * <app-donate-button-preview variant="light"></app-donate-button-preview>
 * ```
 */
@Component({
  selector: 'app-donate-button-preview',
  standalone: false,
  templateUrl: './donate-button-preview.component.html',
  styleUrl: './donate-button-preview.component.scss',
})
export class DonateButtonPreviewComponent {
  variant = input<'light' | 'dark'>('light');

  get imageUrl(): string {
    return this.variant() === 'light'
      ? 'assets/images/icons/donate-buttons-preview-light-button.png'
      : 'assets/images/icons/donate-buttons-preview-dark-button.png';
  }
}
